import { css } from '@emotion/core'
import { colors, measures, spacing } from 'styles/variables'

const { unit } = measures

export const logo = css`
  width: ${4 * unit}px;
`

export const container = css`
  display: flex;

  align-items: center;

  justify-content: center;
`

export const customInwinButton = css`
  max-width: ${spacing(12.5)};
  background-color: ${colors.purples.purple1};
`
